<template>
  <page-list
    :list="list"
    :columns="columns"
    :export-data-options="exportDataOptions"
    default-search-key="brands"
    :placeholder="$t('common.default_search_key',['平台'])">
    <template v-slot:group-actions-append>
      <fixed-label-filter label="活跃频率">
        <a-select v-model="selectedDay" style="width:120px" @change="changeDayType">
          <a-select-option value="all">全部</a-select-option>
          <a-select-option value="1">1天内</a-select-option>
          <a-select-option value="3">3天内</a-select-option>
          <a-select-option value="30">30天内</a-select-option>
          <a-select-option value="365">365天内</a-select-option>
        </a-select>
      </fixed-label-filter>
    </template>
  </page-list>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getNameFilter } from '@/utils/common/tableFilter'
import { getTimeTableColumn } from '@/utils/common/tableColumn'
import { sizestrWithUnit } from '@/utils/utils'

export default {
  name: 'OpensourceReportsList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
    dayType: [String, Number],
    changeDayType: Function,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'opensource_reports',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: {
          brands: getNameFilter({ field: 'brands', label: '平台' }),
          version: getNameFilter({ field: 'version', label: '版本' }),
        },
      }),
      columns: [
        {
          field: 'ip_addr',
          title: 'IP',
          slots: {
            default: ({ row }) => {
              let str = ''
              if (row.country) str += row.country
              if (row.prov) str += str ? `, ${row.prov}` : row.prov
              if (row.city) str += str ? `, ${row.city}` : row.city
              if (row.isp) str += str ? `(${row.isp})` : row.isp
              return [<div>{row.ip_addr}</div>, <div>{str}</div>]
            },
          },
          formatter: ({ row }) => {
            return row.ip_addr
          },
        },
        {
          field: 'version',
          title: '版本',
        },
        {
          field: 'baremetal_cnt',
          title: '裸金属',
          sortable: true,
        },
        {
          field: 'kvm_host_cnt',
          title: 'KVM宿主机',
          sortable: true,
        },
        {
          field: 'kvm_server_cnt',
          title: 'KVM虚拟机',
          sortable: true,
        },
        {
          field: 'kvm_server_cpu_cnt',
          title: 'KVM虚拟机配置',
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<div>cpu: {row.kvm_server_cpu_cnt}</div>, <div>内存：{sizestrWithUnit(row.kvm_server_mem_size_mb, 'M', 1024)}</div>]
            },
          },
          formatter: ({ row }) => {
            return `cpu: ${row.kvm_server_cpu_cnt}, 内存: ${sizestrWithUnit(row.kvm_server_mem_size_mb, 'M', 1024)}`
          },
        },
        {
          field: 'vmware_host_cnt',
          title: 'Vmware宿主机',
          sortable: true,
        },
        {
          field: 'brands',
          title: '平台',
        },
        {
          field: 'server_cnt',
          title: '虚拟机总数量',
          sortable: true,
        },
        {
          field: 'server_cpu_cnt',
          title: '虚拟机总配置',
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<div>cpu: {row.server_cpu_cnt}</div>, <div>内存：{sizestrWithUnit(row.server_mem_size_mb, 'M', 1024)}</div>]
            },
          },
          formatter: ({ row }) => {
            return `cpu: ${row.server_cpu_cnt}, 内存: ${sizestrWithUnit(row.server_mem_size_mb, 'M', 1024)}`
          },
        },
        {
          field: 'container_cnt',
          title: '容器主机数量',
          sortable: true,
        },
        {
          field: 'container_cpu_cnt',
          title: '容器主机总配置',
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<div>cpu: {row.container_cpu_cnt}</div>, <div>内存：{sizestrWithUnit(row.container_mem_size_mb, 'M', 1024)}</div>]
            },
          },
          formatter: ({ row }) => {
            return `cpu: ${row.container_cpu_cnt}, 内存: ${sizestrWithUnit(row.container_mem_size_mb, 'M', 1024)}`
          },
        },
        {
          field: 'updated',
          title: '活跃频率',
          slots: {
            default: ({ row }) => {
              const { updated_at } = row
              const time = this.$moment(updated_at).format()
              const days = this.$moment().diff(time, 'days') + 1
              if (days > 365) {
                return [<span title={time}>{'超过365天'}</span>]
              }
              if (days > 30) {
                return [<span title={time}>{'365天内'}</span>]
              }
              if (days > 3) {
                return [<span title={time}>{'30天内'}</span>]
              }
              return [<span title={time}>{'1天内'}</span>]
            },
          },
          formatter: ({ row }) => {
            const { updated_at } = row
            const time = this.$moment(updated_at).format()
            const days = this.$moment().diff(time, 'days') + 1
            if (days > 365) {
              return '超过365天'
            }
            if (days > 30) {
              return '365天内'
            }
            if (days > 3) {
              return '30天内'
            }
            return '1天内'
          },
        },
        getTimeTableColumn({ field: 'updated_at', title: '活跃时间' }),
      ],
      selectedDay: '30',
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: '开源用户统计',
        downloadType: 'local',
        items: [
          ...this.columns,
          {
            field: 'country',
            title: '地址',
            formatter: ({ row }) => {
              let str = ''
              if (row.country) str += row.country
              if (row.prov) str += str ? `, ${row.prov}` : row.prov
              if (row.city) str += str ? `, ${row.city}` : row.city
              if (row.isp) str += str ? `(${row.isp})` : row.isp
              return str
            },
          },
        ],
      }
    },
  },
  watch: {
    selectedDay () {
      this.list.fetchData()
    },
    dayType: {
      immediate: true,
      handler (val) {
        if (val) {
          this.selectedDay = val
        }
      },
    },
  },
  created () {
    this.list.fetchData()
  },
  activated () {
    this.selectedDay = this.dayType
  },
  methods: {
    getParam () {
      const ret = {
        details: true,
      }
      if (this.selectedDay !== 'all') {
        ret.filter = `updated_at.ge("${this.$moment().utc().subtract(this.selectedDay, 'day').format('YYYY-MM-DD HH:mm:ss')}")`
      }
      return ret
    },
  },
}
</script>
